import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';
import DatabaseService from 'services/DatabaseService.js';
import {initNavbarState, setNavbarTitle, setNavbarEnable} from 'actions/navbar.js';

import {NavControl} from 'modules/navigation/NavBarContainer.js';
import {getUserProfileWithDefaults} from 'reducers/user.js';
import LoadInline from 'modules/loading/LoadInline.js';
import ErrorPage from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js';

import SurveyComplete                       from './SurveyComplete.js'
import SurveyPageText                       from './types/SurveyPageText.js';
import SurveyPageWelcome                    from './types/SurveyPageWelcome.js';
import SurveyPageMCQContainer               from './types/SurveyPageMCQContainer.js';
import SurveyPageContactsMCQContainer       from './types/SurveyPageContactsMCQContainer.js';
import SurveyPageHeightContainer            from './types/SurveyPageHeightContainer.js';
import SurveyPageWeightContainer            from './types/SurveyPageWeightContainer.js';
import SurveyPageWaistContainer             from './types/SurveyPageWaistContainer.js';
import SurveyPageDateContainer              from './types/SurveyPageDateContainer.js';
import SurveyPageMultiSelectContainer       from './types/SurveyPageMultiSelectContainer.js';
import SurveyPageInputNumberContainer       from './types/SurveyPageInputNumberContainer.js';
import SurveyPageUnknown                    from './types/SurveyPageUnknown.js';
import SurveyPagePersonalityType            from './types/SurveyPagePersonalityType.js';
import SurveyPageRecommendationsContainer   from './types/SurveyPageRecommendationsContainer.js';
import SurveyPageCompanyWelcome             from './types/SurveyPageCompanyWelcome.js';
import SurveyPageSyncContactsContainer      from './types/SurveyPageSyncContactsContainer.js';
import SurveyPageSyncCalendarContainer      from './types/SurveyPageSyncCalendarContainer.js';
import SurveyPageUserProfileContainer       from './types/SurveyPageUserProfileContainer.js';
import SurveyPageCalendarSettingsContainer  from './types/SurveyPageCalendarSettingsContainer.js';
import SurveyPageSyncDevicesContainer       from './types/SurveyPageSyncDevicesContainer.js';
import SurveyPageDebug                      from './types/SurveyPageDebug.js';

/*

survey save:
60kg, {1 && 3}
POST /v4/app/activities
{"userChallenges":[{"challengeId":89290,"value":60000},{"challengeId":89296,"value":5}],"surveyId":1}

survey save:
170cm, Answer 2:
POST /v4/app/activities
{"userChallenges":[{"challengeId":89292,"value":1700},{"challengeId":89294,"value":2}],"surveyId":1}


Sept 27 2017, 532 (input a number)
POST /v4/app/activities
{"userChallenges":[{"challengeId":89289,"value":17436},{"challengeId":89295,"value":532}],"surveyId":1}





New Survey Pages

107 : COMANY_WELCOME // data : { welcomerName : <string>, welcomerTitle : <string>, companyName : <string>, message : <string>, logo : <Asset>, photo : <Asset>, toolbar : <bool> }
108 : PROFILE // data : { firstName : <string>, lastName : <string>, avatar : <Asset> } - send data with userChallenge on save, ex, { challengeId: 1, data : {...} }
109 : SYNC_CONTACTS // "read and confirm" type challenge 
3 questions: Type 2 with "canRefresh" flag OR Type 110
111 : SYNC_TRACKER // "read and confirm" type challenge
112 : SYNC_CALENDAR // "read and confirm" type challenge
113 : CALENDAR_SETTINGS // "multiple selection custom" (type 22 challenge)
114 : SYNC_DEVICES // data : { plugins (w/ userPlugins) : [] }, plugin : { id ..., etc, recommended : <bool>,  ...userPlugin }

Structural API Changes:

- Challenge, UserChallenge, and UserChallengeAnswer will now all have a data <string> and dataType <int> field. Intentionally moving away from the old value<int> field to add flexibility. The old value field will remain but be deprecated after the next release.
- When completing a survey question or challenge that sends an value<type> this can be replaced with a data<string> field with the previous int value converted to a string. This is required to support sending data like emails as the answer �value� instead of just a number
- One (hopefully final) change to the mcq and mcs questions. Instead of a sending an array of answerIds, send the answer objects themselves as an array called challengeAnswers : [], ex { userChallenge: { challengeAnswers : [{id: 1, data, etc�}] }. This is required to handle dynamic answers generated from the server or the apps themselves. The server can then decide what to do with the incoming data. The old answerIds will still work but be deprecated.



*/

export const SurveyComponentsByType = {
    0:SurveyPageText,
    1:SurveyPageWelcome,
    2:SurveyPageMCQContainer,
    3:SurveyPageHeightContainer,
    4:SurveyPageWeightContainer,
    5:SurveyPageDateContainer,
    8:SurveyPageWaistContainer,
    9:SurveyPageMultiSelectContainer,
    7:SurveyPageInputNumberContainer,
    105:SurveyPageRecommendationsContainer,
    106:SurveyPagePersonalityType,

    107:SurveyPageCompanyWelcome,
    108:SurveyPageUserProfileContainer,
    109:SurveyPageSyncContactsContainer,
    110:SurveyPageContactsMCQContainer,
    //111:SurveyPageDebug, //Not currently supported for web
    112:SurveyPageSyncCalendarContainer,
    113:SurveyPageCalendarSettingsContainer,
    114:SurveyPageSyncDevicesContainer,
}


const defaultReferrer = '/home';


class SurveyContainer extends Component {
    constructor(props) {
        super(props);
        var referrer = sessionStorage.surveyReferrer;
        var surveyContainerInitialState = {
                state:{survey:null,
                       pageIndex: 0,
                       numPages:0,
                       busy: false,
                       completeResult:null,  
                       error:'',
                       resumed: false,
                       referrer: referrer},
                results: {}
            };
        this.resumeState(surveyContainerInitialState);
        this.state = surveyContainerInitialState.state;
        this.results = surveyContainerInitialState.results;
        this.close = this.close.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSkip = this.onSkip.bind(this);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.onNextStep = this.onNextStep.bind(this);
        this.onPrevStep = this.onPrevStep.bind(this);
        this.preserveState = this.preserveState.bind(this);
        this.saveBefore = this.saveBefore.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(initNavbarState({enable:true, menuEnable:false, backButtonEnable:false, rewardsEnable:false, mode:(this.props.navMode||'normal')}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        if(!this.state.resumed) {
            this.loadData();
        }
    }

    componentWillUnmount() {
        delete sessionStorage.surveyReferrer;
    }

    saveBefore() {
        var survey = this.state.survey;
        var surveyId = survey.id;
        var surveyPages = survey.surveyPages;
        var numPages = surveyPages.length;
        var pageIndex = this.state.pageIndex;
        var surveyPage = surveyPages[pageIndex];
        var userChallenges = this.getUserChallenges();
        var pageId = surveyPage.id;
        return DatabaseService.surveyPageSavePointBefore(surveyId, pageId, userChallenges)
            .then(result=>{
                console.log('SurveyContainer.saveBefore ', result);
                return this.applyLazyLoadedPage(pageIndex, result.page, surveyPages, survey);
            })
            .catch(error=>{
                console.error('SurveyContainer.saveBefore - error ', error);
                this.setState({error:String(error)});
            });
    }

    saveAfter() {
        var survey = this.state.survey;
        var surveyId = survey.id;
        var surveyPages = survey.surveyPages;
        var numPages = surveyPages.length;
        var pageIndex = this.state.pageIndex;
        var surveyPage = surveyPages[pageIndex];
        var saveAfter = surveyPage.saveBefore;
        var userChallenges = this.getUserChallenges();

        var pageId = surveyPage.id;
        var doSaveAfter = saveAfter || this.pageHasFollowUp(surveyPage);
        if(doSaveAfter) {
            return DatabaseService.surveyPageSavePointAfter(surveyId, pageId, userChallenges)
                .then(result=>{
                    console.log('SurveyContainer.saveAfter ', result);
                    return this.applySaveAfterPages(pageIndex, result.pages, surveyPages, survey);
                })
                .catch(error=>{
                    console.error('SurveyContainer.saveAfter - error ', error);
                    this.setState({error:String(error)});
                });
        } else {
            return Promise.resolve(false);
        }
    }

    completeSurvey() {
        var survey = this.state.survey;
        var surveyId = survey.id;
        var surveyPages = survey.surveyPages;
        var numPages = surveyPages.length;
        var pageIndex = this.state.pageIndex;
        var pageIsLazy = !this.state.end && surveyPages[pageIndex].lazyLoad;

        var userChallenges = this.getUserChallenges();
        console.log('complete survey: userChallenges: ', userChallenges, 'surveyId: ' + surveyId);
        this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
        return DatabaseService.completeSurvey(surveyId, userChallenges)
            .then((result)=>{
                console.log('SurveyContainer -> completeSurvey', result);
                this.props.dispatch(setNavbarEnable(false));
                if(this.props.noCompleteScreen) {
                    this.onCompleted();
                } else {
                    this.setState({completeResult: result});
                }
            })
            .catch((error)=>{
                console.error('SurveyContainer.onNextStep - error ', error);
                this.setState({error:String(error)});
            })
            .then(()=>{
                this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
            });
    }

    getSurveyIdOrTag() {
        return (this.props.surveyId || this.props.match.params.id);
    }

    filterSurveyPages(result) {
        if(result && result.survey && result.survey.surveyPages) {
            result.survey.surveyPages = result.survey.surveyPages.filter(this.filterSurveyPage);
        }
        return result;
    }
    filterSurveyPage(surveyPage) {
        if(surveyPage.type===111) {
            return false;
        } else if (surveyPage.type===109) {
            return false;
        }

        return true;
    }

    loadData() {
        this.setState({busy:true});
        DatabaseService.getSurvey(this.getSurveyIdOrTag(), this.props.micro)
                            .then((result) => {
                                console.log('SurveyContainer.loadData', result);
                                this.filterSurveyPages(result);
                                var survey = result.survey;
                                var surveyPages = survey.surveyPages;
                                if(surveyPages.length==0) {
                                    this.onEmpty();
                                } else {
                                    var numPages = surveyPages.length;
                                    this.props.dispatch(setNavbarTitle(survey.title));
                                    return new Promise((resolve, reject) => {
                                        this.setState({survey:survey, numPages}, ()=>resolve(survey));
                                    }).then(()=>this.lazyLoad());
                                }
                            }).catch((error)=>{
                                console.error("Error: ", error);
                                this.setState({error:String(error)});
                            }).then(()=>{
                                this.setState({busy:false});
                            });
    }

    onEmpty() {
        if(this.props.onEmpty) {
            this.props.onEmpty();
        } else {
            this.props.history.push(this.state.referrer || defaultReferrer);
        }
    }

    lazyLoad() {
        var survey = this.state.survey;
        var surveyPages = survey.surveyPages;
        var numPages = surveyPages.length;
        var pageIndex = this.state.pageIndex;
        if(0 <= pageIndex && pageIndex < numPages) {
            var surveyPage = surveyPages[pageIndex];
            if(Boolean(surveyPage.uri)) {
                return DatabaseService.httpJson('GET', surveyPage.uri, null, {absoluteUrl:true})
                        .then(result => {
                            console.log('SurveyContainer.lazyLoad', result);
                            return this.applyLazyLoadedPage(pageIndex, result.page, surveyPages, survey);
                        })
                        .catch(error =>{
                            console.error("Error: ", error);
                            this.setState({error:String(error)});
                        });
            }
        }
        return Promise.resolve(false);
    }

    getSurveyDeepCopy(survey) {
        return JSON.parse(JSON.stringify(survey));
    }

    applyLazyLoadedPage(pageIndex, newPage, surveyPages, survey) {
        var updatedSurveyPages = surveyPages.map((p,i) => i===pageIndex ? {...p, ...newPage} : p );
        var updatedSurvey = {...survey, surveyPages:updatedSurveyPages};

		return new Promise((resolve, reject) => {
            this.setState({survey:updatedSurvey}, ()=>resolve(updatedSurvey));
		});
    }

    applySaveAfterPages(pageIndex, newSurveyPages, surveyPages, survey) {
        var a = surveyPages.slice(0,pageIndex+1);
        var b = pageIndex < surveyPages.length ? surveyPages.slice(pageIndex+1,surveyPages.length) : [];
        var updatedSurveyPages = a.concat(newSurveyPages).concat(b);
        console.log('SurveyContainer.applySaveAfterPages', {surveyPages, pageIndex, a, b, updatedSurveyPages});
        var updatedSurvey = {...survey, surveyPages:updatedSurveyPages};
        var numPages = updatedSurveyPages.length;

		return new Promise((resolve, reject) => {
            this.setState({survey:updatedSurvey, numPages:numPages}, ()=>resolve(updatedSurvey));
		});
    }

    onSubmit(event, userChallenge, savedState) {
        console.log('SurveyContainer.onSubmit - userChallenge=>', userChallenge);
        if(!userChallenge) {
            var pageIndex = this.state.pageIndex;
            var survey = this.state.survey;
            var surveyPages = survey.surveyPages;
            var surveyPage = surveyPages[pageIndex];
            userChallenge = surveyPage.challengeId ? {challengeId:surveyPage.challengeId} : null;
            console.log('SurveyContainer.onSubmit - creating default userChallenge=>', userChallenge);
        }
        this.next(userChallenge, savedState);
        event && event.preventDefault();
    }

    onSkip(event) {
        this.next(null);
    }

    next(userChallenge, savedState) {
        var pageIndex = this.state.pageIndex;
        this.results[pageIndex] = {userChallenge:userChallenge, savedState:savedState, survey:this.getSurveyDeepCopy(this.state.survey)};
        this.setState({busy:true});
        this.saveAfter() //numPages and survey might change inside during this method invocation
            .then(()=>{
                var end = pageIndex==this.state.numPages-1;
                var nextPageIndex = Math.min(pageIndex+1,this.state.numPages-1)
                this.setState(
                    {end:end, pageIndex:nextPageIndex},
                    this.onNextStep
                );
            });
    }

    prev() {
        var pageIndex = this.state.pageIndex;
        if(pageIndex > 0) {
            var prevPageIndex = pageIndex-1;
            var survey = this.state.survey;
            var result = this.results[prevPageIndex];
            if(result) {
                result.userChallenge = null;
                survey = result.survey || survey;
                result.survey = null;
            }
            this.setState({survey:survey, pageIndex:Math.max(0,prevPageIndex)},
                this.onPrevStep
            );
        }
    }

    close() {
        if(this.props.onClose) {
            this.props.onClose();
        } else {
            this.props.history.push(this.state.referrer || defaultReferrer);
        }
        this.results = {};
    }

    onCompleted() {
        if(this.props.onCompleted) {
            this.props.onCompleted();
        } else {
            this.props.history.push(this.state.referrer || defaultReferrer);
        }
        this.results = {};
    }

    getUserChallenges() {
        return Object.values(this.results).map(r=>r.userChallenge).filter((uc)=>(uc!=null));
    }

/*
on entering a page do saveBefore else check uri else display as is
send all answers up to the current point
on exiting a page do saveAfter if saveAfter === true or a challengeAnswer.followUp === true
send all answers up to and including the current page
saveBefore POST /v4/app/surveys/:surveyId/pages/:pageId same signature as POST /activities
saveAfter POST /v4/app/surveys/:surveyId/pages/:pageId/pages same signature
saveBefore will return a page object same as the uri request
all answers are to be posted to /activities at the end of the survey
*/
    onNextStep() {
        window.scrollTo(0, 0);
        var survey = this.state.survey;
        var surveyId = survey.id;
        var end = this.state.end;


        var promise = Promise.resolve();
        if(end) {
            promise = this.completeSurvey();
        } else {
            var surveyPages = survey.surveyPages;
            var pageIndex   = this.state.pageIndex;
            console.log('SurveyContainer.onNextStep ', {surveyPages, pageIndex});
            var surveyPage  = surveyPages[pageIndex];
            var saveBefore  = surveyPage.saveBefore;
            var doLazyLoad  = Boolean(surveyPage.uri);

            var doSaveBefore = saveBefore;

            if(doSaveBefore) {
                promise = this.saveBefore();
            } else if(doLazyLoad) {
                promise = this.lazyLoad();
            }
        }
        promise.then(()=>{
            this.setState({busy:false});
        });
    }

    /*
    clearPersistedAnswers() {
        var clearedResults = {};
        Object.keys(this.results).forEach(key=> {
            var r = this.results[key];
            clearedResults[key] = {...r, userChallenge:null};
        });
        this.results = clearedResults;
        
    }
    */

    onPrevStep() {
        window.scrollTo(0, 0);
    }

    getCompletePercent(result) {
        var progress = result.progress;
        var activitiesCompleted = progress.activitiesCompleted;
        var activitiesRequired = progress.activitiesRequired;
        return Math.round(Math.min(100,(activitiesCompleted/activitiesRequired)*100));
    }

    getSurveyComponentByType(type) {
        return SurveyComponentsByType.hasOwnProperty(type) ? SurveyComponentsByType[type] : SurveyPageUnknown;
    }

    getSavedState(pageIndex) {
        var result = this.results[pageIndex];
        return result ? result.savedState : null;
    }

    preserveState() {
        var surveyContainerState = {state:this.state, results:this.results};
        sessionStorage.surveyContainerState = JSON.stringify(surveyContainerState);
    }

    resumeState(initialState) {
        if(sessionStorage.surveyContainerState) {
            var surveyIdOrTag = this.getSurveyIdOrTag();
            var surveyContainerState = JSON.parse(sessionStorage.surveyContainerState);
            if(surveyContainerState.results && 
               surveyContainerState.state && 
               surveyContainerState.state.survey/* && 
               (String(surveyContainerState.state.survey.id)===String(surveyIdOrTag) || )*/) {
                initialState.results = surveyContainerState.results;
                initialState.state   = surveyContainerState.state;
                initialState.state.resumed = true;
            }
            delete sessionStorage.surveyContainerState;
        }
    }

    pageHasFollowUp(surveyPage) {
        var result = false;
        var challengeAnswers = Utils.deref(surveyPage, 'challenge.challengeAnswers', null);
        if(challengeAnswers) {
            challengeAnswers.forEach(ca => {
                if(ca.hasFollowUp) {
                    result = true;
                }
            });
        }
        return result;
    }


    render() {
        if(this.state.error) {
            return (
                    <NavControl onClose={this.props.noClose ? null : this.close} closeIconOpts={this.props.closeIconOpts}>
                        <ErrorPage error={this.state.error} />
                    </NavControl>
                    );
        } else if(this.state.busy || this.state.survey==null) {
            return (
                    <NavControl onClose={this.props.noClose ? null : this.close} closeIconOpts={this.props.closeIconOpts}>
                        <LoadInline centered vcentered /> 
                    </NavControl>
                    );
        } else if (this.state.completeResult) {
            return <SurveyComplete result={this.state.completeResult} onClose={this.close} completePercent={this.getCompletePercent(this.state.completeResult)}/>; 
        } else {
            var survey = this.state.survey;
            var surveyPages = survey.surveyPages;
            var numPages = surveyPages.length;
            var pageIndex = Math.max(0,Math.min(numPages-1,this.state.pageIndex));
            var firstPage = (pageIndex==0);
            var surveyPage = surveyPages[pageIndex];
            var SurveyPageComponent = this.getSurveyComponentByType(surveyPage.type);
            return (
                    <NavControl closeIconOpts={firstPage ? this.props.closeIconOpts : {key:'1', name:'chevron left'}} onClose={firstPage ? (this.props.noClose ? null : this.close) : this.prev}>
                        <SurveyPageComponent 
                            userProfile={this.props.userProfile}
                            savedState={this.getSavedState(pageIndex)}
                            key={surveyPage.id} 
                            surveyPage={surveyPage} 
                            onSubmit={this.onSubmit} 
                            onSkip={this.onSkip} 
                            onPrev={this.prev} 
                            preserveState={this.preserveState}
                            saveBefore={this.saveBefore}
                            survey={survey}
                            pageNum={pageIndex+1}
                            numPages={numPages} />
                    </NavControl>
                    );
        }
    }

}

const mapStateToProps = (state, ownProps) => {
    return { userProfile: getUserProfileWithDefaults(state.user) };
}
export default withRouter(connect(mapStateToProps)(SurveyContainer));



// WEBPACK FOOTER //
// ./src/modules/surveys/SurveyContainer.js